







import Vue from 'vue'
import { mountAppointmentModal, getCalendarData, } from '../../util/calendar_modal'
import { isFeatureLive } from './settings/GhlLabs/features'

export default Vue.extend({
  name: 'calendar-v2',
  data() {
    return {
      currentLocationId: '',
    }
  },
  watch: {
    '$route.params.location_id': async function (id) {
      this.currentLocationId = id
      this.mountCalendarViewApp()
    },
  },
  computed:{
    isServicesEnabled(): boolean {
      return this.$store.getters['calendars/isServicesEnabled']
    },
    isNotificationBannerVisible(): boolean {
      return this.$store.state.notification.showNotification
    },
    cssVars() {
      return {
        '--calendar-height': this.isNotificationBannerVisible ? '77%' : '82%'
      }
    }
  },
  async created() {
    this.currentLocationId = this.$router.currentRoute.params.location_id
  },
  async mounted() {
    this.mountCalendarViewApp()
  },
  methods: {
    async mountCalendarViewApp() {
      const data = await getCalendarData(this.currentLocationId);
      mountAppointmentModal('CalendarPage', {
        userId: data.userId,
        locationId: data.locationId,
        timezone: data.timeZone,
        calendars: data.calendars,
        groups: data.groups,
        users: data.users,
        services: data.services,
        router: this.$router,
        route: this.$route,
        data: data,
        isServicesEnabled: this.isServicesEnabled,
        store: data.store,
        customObjectLabels: data.customObjectLabels
      })
    },
  }
})
